import { Platform } from 'react-native';

import storage from '@lib/utils/storage';

const STORAGE_KEY = 'persistedSelectedCard';

export const PERSISTED_APPLE_PAY_ID = 'apple_pay';

interface PersistedValue {
    userId: number;
    cardId: string;
}

function isMobile(): boolean {
    return Platform.OS !== 'web';
}

export async function setPersistedSelectedCard(userId: number, cardId: string): Promise<void> {
    if (!isMobile()) {
        return;
    }
    await storage.setItemAsync(STORAGE_KEY, JSON.stringify({ userId, cardId } as PersistedValue));
}

export async function clearPersistedSelectedCard(): Promise<void> {
    if (!isMobile()) {
        return;
    }
    await storage.deleteItemAsync(STORAGE_KEY);
}

export async function getPersistedSelectedCard(userId: number): Promise<string | undefined> {
    if (!isMobile()) {
        return undefined;
    }
    try {
        const raw = await storage.getItemAsync(STORAGE_KEY);
        if (!raw) {
            return undefined;
        }
        const parsed: PersistedValue = JSON.parse(raw);
        if (parsed.userId !== userId) {
            return undefined;
        }
        return parsed.cardId;
    } catch {
        return undefined;
    }
}
